export const SUBSCRIPTION_REQUIRED_CODE = 'SUBSCRIPTION_REQUIRED'

export function getResponseCode(response) {
  return response?.code || response?.errorCode || response?.error
}

export function isSubscriptionRequired(response) {
  return getResponseCode(response) === SUBSCRIPTION_REQUIRED_CODE
}

export function getSubscriptionAvailability(response) {
  return response?.availability?.subscription || null
}

export function hasSubscriptionAccess(subscriptionAvailability) {
  return subscriptionAvailability?.hasAccess !== false
}

export function getSubscriptionCtaText(reason) {
  if (reason === 'SUBSCRIPTION_NOT_FOUND') return 'Оформите подписку'
  if (reason === 'SUBSCRIPTION_INACTIVE') return 'Продлите подписку'
  return 'Нужна активная подписка'
}

export function getSubscriptionBlockedHint(reason) {
  if (reason === 'SUBSCRIPTION_NOT_FOUND') return 'Оформите подписку, чтобы управлять карточками.'
  if (reason === 'SUBSCRIPTION_INACTIVE') return 'Продлите подписку, чтобы снова управлять карточками.'
  return 'Для этого действия нужна активная подписка.'
}

export function emitSubscriptionRequired(detail = {}) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent('subscription-required', { detail }))
}
